import React from "react";
import Badge from "@material-ui/core/Badge";
import { DatePicker } from "@material-ui/pickers";
import { makeJSDateObject } from "../utils/helpers";

const HoursCalendar = (props) => {
  const { date, changeDate, selectedDays } = props;

  return (
    <DatePicker
      autoOk
      orientation="portrait"
      variant="static"
      openTo="date"
      disableFuture={true}
      value={date}
      onChange={(newDate) => {

        changeDate(newDate);
      }}
      onMonthChange={(newDate) => {

        changeDate(newDate);
      }}
      onYearChange={(newDate) => {

        changeDate(newDate);
      }}
      renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
        const date = makeJSDateObject(day);
        const isSelected =
          isInCurrentMonth && selectedDays.includes(date.getDate());
        return !isSelected ? (
          dayComponent
        ) : (
          <Badge color="secondary" overlap="circular" variant="dot">
            {dayComponent}
          </Badge>
        );
      }}
    />
  );
};

export default HoursCalendar;
